import Constants from 'expo-constants';

const extra = (Constants.expoConfig?.extra ?? {}) as {
  adsenseClientId?: string;
  adsenseBannerSlot?: string;
};

/**
 * Google AdSense (web only). Native apps use AdMob via adMobConfig.
 *
 * Create a display ad unit in AdSense, then set:
 *   EXPO_PUBLIC_ADSENSE_CLIENT_ID=ca-pub-xxxxxxxx
 *   EXPO_PUBLIC_ADSENSE_BANNER_SLOT=1234567890
 */
export const ADSENSE_CONFIG = {
  clientId:
    process.env.EXPO_PUBLIC_ADSENSE_CLIENT_ID ??
    extra.adsenseClientId ??
    '',
  bannerSlot:
    process.env.EXPO_PUBLIC_ADSENSE_BANNER_SLOT ??
    extra.adsenseBannerSlot ??
    '',
};

export const isAdsenseConfigured = (): boolean =>
  Boolean(ADSENSE_CONFIG.clientId && ADSENSE_CONFIG.bannerSlot);
